export interface PracticeCard {
  image: string;
  title: string;
  text: string;
}

export const practiceCards: PracticeCard[] = [
  {
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4e2ff5fc-db28-41d0-a31a-8f3b10f51964.jpg',
    title: 'Ficha práctica: Defensa en 6:0',
    text: 'Claridad absoluta: olvida los párrafos eternos. Cada ejercicio incluye el objetivo, la configuración en pista y las correcciones exactas.'
  },
  {
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/a1a75600-0771-416b-9d7f-fe38851887fc.jpg',
    title: 'Ficha práctica: Progresión de Remate',
    text: 'Progresión profesional: dividimos los gestos complejos en pasos sencillos, desde la colocación de los pies hasta el contacto final, para enseñar técnica de élite.'
  },
  {
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/088358df-ec42-4c2b-955b-68afc7552018.jpg',
    title: 'Fichas prácticas diseñadas para consultar en 30 segundos',
    text: 'Un sistema completo de referencia rápida: identifica el sistema táctico, revisa las claves y llévalo directo al banquillo.'
  }
];
